import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconFusionGradient = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={34}
    fill="none"
    viewBox="0 0 34 34"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#icon-fusion-gradient_svg__a)">
      <path
        fill="url(#icon-fusion-gradient_svg__b)"
        d="M8.25 25.836c.195-1.68 1.21-6.016 6.25-9.297-5.04-3.32-6.055-7.656-6.25-9.336-.04-.351.234-.664.625-.664h1.25a.569.569 0 0 1 .625.508c.04.195.078.43.117.742h12.227c.039-.273.078-.547.117-.742.039-.313.312-.508.625-.508h1.25c.39 0 .664.313.625.664-.195 1.875-1.445 7.11-8.164 10.43-1.25.625-2.266 1.289-3.086 2.031h5c-.234-.195-.43-.39-.664-.586.82-.43 1.601-.898 2.265-1.367 3.672 3.125 4.493 6.64 4.649 8.125.039.352-.234.664-.625.664l-1.25.04c-.313 0-.586-.274-.625-.548-.04-.195-.078-.469-.156-.703H10.867c-.039.273-.078.508-.117.703a.632.632 0 0 1-.625.547l-1.25-.039c-.39 0-.703-.313-.625-.664Zm8.71-10.742a11.538 11.538 0 0 0 2.54-1.719h-5.04c.704.625 1.524 1.172 2.5 1.719Zm5.157-4.844H11.844c.195.39.469.82.82 1.25h8.633c.312-.39.586-.82.82-1.25Zm-10.234 12.5h10.195a8.597 8.597 0 0 0-.82-1.25h-8.594c-.312.39-.586.82-.781 1.25Z"
      />
    </g>
    <defs>
      <linearGradient
        id="icon-fusion-gradient_svg__b"
        x1={27}
        x2={8.025}
        y1={7}
        y2={26.974}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
      <filter
        id="icon-fusion-gradient_svg__a"
        width={36}
        height={36.039}
        x={-1}
        y={0.5}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6025_5377"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_6025_5377"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_6025_5377"
          result="effect2_dropShadow_6025_5377"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_6025_5377"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
));
export default SvgIconFusionGradient;
